/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import styled from "@mui/styled-engine-sc";
import EspotGeneral from "components/custom/spot/SpotTemplate";
import { useTheme } from "@mui/material";
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


/**
 * MiniCart component
 * displays number of cart items icon
 * @param props
 */


const StyledMegaMenuHeader = styled("header")`
  ${({ theme }) => `
    background-color: ${theme.palette.background.paper};
    border-bottom: solid ${theme.palette.primary.main} 1px;
    height: 55px;
    box-shadow: none !important;
    z-index: 20;
    
    .header-branding-menu-mobile {
      display: flex;
      position: relative;
      align-items: center;

      a {
        display: block;
        line-height: 1;
      }

      img {
        padding-left: 15px;
        width: 135px;
        height: auto;
      }
      
      @media (max-width: 450px) {
        margin-left: 0px;
      }
    }

    .close-menu-icon {
      display: flex;
      position: relative;
      align-items: center;
      svg {
        justify-content: center;
        align-items: center;
        font-size: 25px;
      }
      padding: 0px 16px 0px 0px;
    }

    .header-megamenu-topbarSection {
      height: 55px;
      width: auto;
  
      ${theme.breakpoints.down("md")} {
        height: 55px;
      }
    }

    `}
  `;

const MegaMenuHeader = () => {
  
  const theme = useTheme();

  return (
    <StyledMegaMenuHeader>
        <StyledGrid className="header-megamenu-topbarSection" container alignItems="center">
            <StyledGrid item alignItems="center" xs={6}>
                <div className="header-branding-menu-mobile">
                    <EspotGeneral espotName="LogoHeader" />
                </div>
            </StyledGrid>
            <StyledGrid item alignItems="center" xs={6}>
              <StyledGrid className="header-topbarSection" container justifyContent="flex-end" alignItems="center">
                <div className="close-menu-icon">
                  <HighlightOffIcon/>
                </div>
              </StyledGrid>
            </StyledGrid>
        </StyledGrid>
    </StyledMegaMenuHeader>
  );
};


export default MegaMenuHeader;